import {EntityModel} from "@fedeltapointofsale/data-client";
import {EmailSettingData} from "./email-setting.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class EmailSettingEntityModel extends EntityModel<EmailSettingData> {

    constructor(injector: Injector) {
        super(injector, EmailSettingData);
    }
}
